import React, { useEffect } from "react";
import { useSelector } from "react-redux";

const ThemeProvider = ({ children }) => {
    const themeColor = useSelector(state => state?.login?.userDetails?.company?.color);

    useEffect(() => {
        if (themeColor) {
            document.documentElement.style.setProperty("--bg-base-color", `var(${themeColor})`);
        }
    }, [themeColor]);

    return <>{children}</>;
};

export default ThemeProvider;
